import { configureStore } from '@reduxjs/toolkit';

import templateReducer from './slices/TemplateSlice';
import notificationReducer from './slices/NotificationSlice';

const store = configureStore({
  reducer: {
    currentTemplate: templateReducer,
    notification: notificationReducer,
  },
});

export default store;
